import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { Notificationtype } from './Enums'
/**
* Class NotificationsListCountRequestQuery
*  Query params for operation "NotificationsListCount"
*/
export class NotificationsListCountRequestQuery extends ActiveModel {

/**
  * CreatedBefore
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  CreatedBefore?: string


/**
  * CreatedAfter
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  CreatedAfter?: string


  /**
  * Viewed
  * Фильтр по состоянию просмотра уведомления пользователем: <br>true - только просмотренные; <br>false - только не просмотренные<br>  */
  @ActiveField()
  Viewed?: boolean


  /**
  * Delivered
  * Фильтр по состоянию доставки уведомления до пользователя хотя бы через один из каналов распространения: <br>true - только доставленные; <br>false - только не доставленные<br>  */
  @ActiveField()
  Delivered?: boolean


/**
  * Types
  * Фильтр по типам уведомлений.<br>Если null или пустой список, то вернуть все типы<br>  */
  @ActiveField({
    setter(model: NotificationsListCountRequestQuery, prop: string, value: Array<Notificationtype> | undefined, receiver?: NotificationsListCountRequestQuery ) {
      return Reflect.set(
        model,
        prop,
        value ?  (Array.isArray(value) ? value : [value]) : value, 
        receiver)
    }
  })
  Types?: Array<Notificationtype>
}
